import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";

import { useRecordTeamView, type TeamPageVisit } from "./useHomeTeamViews";

const RecordTeamView = ({ team }: { team: TeamPageVisit | undefined }) => {
  useRecordTeamView(team);
  return null;
};

/**
 * Team page visit log. Mounts the recorder only when the workspace toggle is on,
 * so a workspace with `enableHomeV2` off does not read or write user preferences.
 */
export const TeamViewRecorder = ({
  team,
}: {
  team: TeamPageVisit | undefined;
}) => {
  const { enableHomeV2 } = useWorkspaceFeatureFlags();
  if (enableHomeV2 !== true) {
    return null;
  }
  return <RecordTeamView team={team} />;
};
